"use strict";

exports.__esModule = true;
exports.default = void 0;

var _cardValidator = _interopRequireDefault(require("card-validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CardHelper =
  /*#__PURE__*/
  function () {
    function CardHelper() {
      _classCallCheck(this, CardHelper);

      _cardValidator.default.creditCardType.addCard({
        niceType: 'Dankort',
        type: 'dankort',
        patterns: [5019],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
          name: 'CVC',
          size: 3
        }
      });

      _cardValidator.default.creditCardType.addCard({
        niceType: 'Laser',
        type: 'laser',
        patterns: [6706, 6771, 6709],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
          name: 'CVC',
          size: 3
        }
      });

      _cardValidator.default.creditCardType.addCard({
        niceType: 'Naranja',
        type: 'naranja',
        patterns: [589562],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
          name: 'CVC',
          size: 3
        }
      });

      _cardValidator.default.creditCardType.updateCard('hipercard', {
        patterns: [384100, 384140, 384160, 606282, 637095, 637568],
        lengths: [16, 19]
      });

      _cardValidator.default.creditCardType.updateCard('maestro', {
        patterns: [5018, 5020, 5038, 6304, 6703, 6708, 6759, 6761, 6762, 6763, 5010],
        lengths: [16, 18]
      });

      _cardValidator.default.creditCardType.updateCard('mastercard', {
        lengths: [16, 19]
      });
    }

    _createClass(CardHelper, [{
      key: "wrapValid",
      value: function wrapValid(cardNumber) {
        var numberValid = _cardValidator.default.number(cardNumber);

        if (numberValid.card) {
          if (numberValid.card.type === 'naranja') {
            numberValid.isPotentiallyValid = true;
            numberValid.isValid = true;
          }
          if (numberValid.card.type === 'maestro') {
            numberValid.isPotentiallyValid = true;
            numberValid.isValid = true;
          }
        }

        return numberValid;
      }
    }, {
      key: "isCardNumberValid",
      value: function isCardNumberValid(cardNumber) {
        var cardValid = this.wrapValid(cardNumber);
        return cardValid && cardValid.isValid;
      }
    }, {
      key: "getCardType",
      value: function getCardType(number) {
        var numberValid = this.wrapValid(number);

        if (numberValid.isPotentiallyValid && numberValid.card) {
          return this.convertIssuerName(numberValid.card.type);
        }

        return 'unknown';
      }
    }, {
      key: "convertIssuerName",
      value: function convertIssuerName(issuerName) {
        if (issuerName === 'american-express') {
          return 'amex';
        }

        if (issuerName === 'diners-club') {
          return 'dinersclub';
        }

        return issuerName;
      }
    }]);

    return CardHelper;
  }();

var _default = new CardHelper();

exports.default = _default;